<template>
  <div class="content">
    <div class="bodycontent">
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h3>会员卡信息</h3>
          </div>
        </el-col>
      </el-row>

      <div class="show-card">
        <div class="card-con">
          <el-card class="box-card">
            <div class="text item">
              <span>商户名称</span>
              <span>{{ cardInfo.brand_name }}</span>
            </div>
            <div class="text item">
              <span>卡券名称</span>
              <span>{{cardInfo.title}}</span>
            </div>
            <div class="text item">
              <span>使用提醒</span>
              <span>{{cardInfo.notice}}</span>
            </div>
            <div class="text item">
              <span>使用说明</span>
              <span>{{cardInfo.description}}</span>
            </div>
            <div class="text item">
              <span>客服电话</span>
              <span>{{cardInfo.service_phone}}</span>
            </div>
            <div class="text item">
              <span>创建数量</span>
              <span>{{cardInfo.num}}</span>
            </div>
          </el-card>
          <el-card class="box-card">
            <div class="text item">
              <span>当前状态</span>
              <el-tag
                style="flex:none"
                :type="cardInfo.status | status_btn"
              >{{cardInfo.status | card_status}}</el-tag>
            </div>
            <div class="text item">
              <span>开卡字段</span>
              <div class="card-set">
                <el-table
                  :data="cardInfo.open_field"
                  style="width: 100%"
                  :header-cell-style="setHeader"
                >
                  <el-table-column prop="title" label="信息"></el-table-column>
                  <el-table-column prop="checked" label="启用">
                    <template slot-scope="scope">
                      <el-checkbox
                        disabled
                        :checked="scope.row.checked ? true:false"
                        v-model="scope.row.checked"
                      ></el-checkbox>
                    </template>
                  </el-table-column>
                  <el-table-column prop="required" label="必填">
                    <template slot-scope="scope">
                      <el-checkbox
                        disabled
                        :checked="scope.row.required ? true:false"
                        v-model="scope.row.required"
                      ></el-checkbox>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-card>
        </div>

        <div class="phone-con">
          <SidePhone
            :title="cardInfo.title"
            :store="cardInfo.brand_name"
            :logoUrl="cardInfo.logo_url"
            :nowCardBg="now_color"
          ></SidePhone>
        </div>
      </div>
      <div class="bot-btn">
        <el-button
          type="primary"
          round
          plain
          icon="el-icon-edit"
          @click="editCard(cardInfo.card_id)"
        >编辑</el-button>
        <el-button
          type="danger"
          round
          plain
          icon="el-icon-delete"
          @click="delCard(cardInfo.card_id)"
        >删除</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SidePhone from "./vipCard";
import {
  getWeChatCardList,
  delWxCard,
  editWxCard,
  getWxCardDetail,
  getColor
} from "@/api/vip";
export default {
  components: {
    SidePhone
  },
  computed: {
    ...mapGetters(["token", "app_id"]),
    bgColor: function(val) {
      this.nowCardBg = `background:${val}`;
    }
  },
  filters: {
    card_status: function(val) {
      switch (val) {
        case 0:
          return "待审核";
        case 1:
          return "已审核";
        case 2:
          return "审核驳回";
        default:
          break;
      }
    },
    status_btn: function(val) {
      switch (val) {
        case 0:
          return "warning";
        case 1:
          return "success";
        case 2:
          return "info";
        default:
          break;
      }
    }
  },
  data() {
    return {
      cardArr: [],
      cardInfo: {},
      now_color: "",
      activities: [
        {
          content: "活动按期开始",
          timestamp: "2018-04-15"
        },
        {
          content: "通过审核",
          timestamp: "2018-04-13"
        },
        {
          content: "创建成功",
          timestamp: "2018-04-11"
        }
      ]
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },
  methods: {
    // 卡券详情
    // 卡券详情
    getDetail(id) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        card_id: id
      };
      getWxCardDetail(data).then(res => {
        if (res.code == 200) {
          this.cardInfo = res.data;
          // 卡券颜色
          this.getCardColor(res.data.color);
        }
      });
    },
    // 卡券背景颜色
    getCardColor(color) {
      getColor({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          for (let i in res.data) {
            if (res.data[i].name == color) {
              this.now_color = `background: ${res.data[i].value}`;
              return;
            }
          }
        }
      });
    },
    getList() {
      let data = { token: this.token, app_id: this.app_id };
      getWeChatCardList(data).then(res => {
        if (res.code == 200) {
          if (res.data.length) {
            this.cardArr = res.data;
            this.getDetail(res.data[0].card_id);
          } else {
            this.$alert('您尚未创建会员卡,', '提示', {
              confirmButtonText: '去创建',
              callback: action => {
                this.$router.push('mywxard')
              }
            });
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 编辑卡券
    editCard(card_id) {
      this.$router.push({
        path: "mywxard?id=" + card_id
      });
    },
    // 删除卡券
    delCard(id) {
      this.$confirm("此操作将永久删除该卡券, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delWxCard({
            token: this.token,
            app_id: this.app_id,
            card_id: id
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    setHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return this.headerStyle;
      } else {
        return "";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../business/sub_com";
.bodycontent {
  background: #fff;
  padding: 30px 27px 0;
}
.grid-content {
  display: flex;
}
.show-card {
  widows: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  .card-con {
    width: 60%;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    .box-card {
      .item {
        line-height: 40px;
        color: #363636;
        display: flex;
        border-bottom: 1px solid #f1f1f1;
        justify-content: flex-start;
        span:nth-child(1) {
          width: 100px;
        }
        span:nth-child(2) {
          flex: 1;
          text-align: left;
        }
      }
    }
    .box-card:nth-child(2) {
      margin-top: 20px;
    }
  }

  .phone-con {
    min-width: 375px;
    height: 700px;
    padding: 0 10px;
    border: 1px solid #dfdfdf;
    background: #ffffff;
  }
}
.bot-btn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>